<template>
  <div v-if="bonusData"
       :class="'uk-dropdown tm-dropdown ' + dialogClass"
       style="width: 400px;"
       :data-uk-dropdown="'animation: uk-animation-slide-top-small; pos: '+dialogPosition+'; delay-hide: 400; delay-show: 0; offset: '+dialogOffset+''">
    <div class="uk-margin-small">
      <template v-if="bonusData.type && bonusData.type == 'old'">
        {{ local_page_keys.your_bonus_was }}
      </template>
      <template v-else>
        {{ local_page_keys.your_bonus_is_now }}
      </template>
      <b>+{{ Math.round(bonusData.now) }}%</b>
    </div>
    <div v-if="bonusData.place" class="uk-margin-small">
      {{ local_page_keys.you_are_on }} <b>#{{ bonusData.place }}</b> {{ local_page_keys.place_in_the_overall_rating_among_examiners }}
    </div>
    <div v-if="bonusData.rating && Object.keys(bonusData.rating).length > 0" class="uk-margin-small">
      <div class="uk-margin-small">
        {{ local_page_keys.leaders_in_the_rating }}:
      </div>
      <template v-for="(pro,index) in bonusData.rating">
        <div :key="index" v-if="pro" class="uk-margin-small uk-margin-auto uk-width-small">
          <md-icon v-if="pro.place == 1" style="color: #FFD700">emoji_events</md-icon>
          <md-icon v-if="pro.place == 2" style="color: #C0C0C0">emoji_events</md-icon>
          <md-icon v-if="pro.place == 3" style="color: #CD7F32">emoji_events</md-icon>
          #{{ pro.place }} - {{ Math.round(pro.now) }}%<span style="display: none">{{ pro.user_id }}</span>
        </div>
      </template>
    </div>
    <div class="uk-margin-small">
      {{ local_page_keys.rating_message_part_1 }}<br>
      {{ local_page_keys.rating_message_part_2 }}
    </div>
  </div>

</template>

<script>
export default {
  props: {
    bonusData: {
      type: Object,
    },
    dialogPosition: {
      type: String,
      default: 'bottom-center',
    },
    dialogOffset: {
      type: String,
      default: '0',
    },
    dialogClass: {
      type: String,
    }
  },
  data() {
    return {
      local_page_keys: {},
    }
  },
  async created() {
    this.local_page_keys = await this.$filtergetLocalisationPage('pro_retoucher_progress_report');
  }
}
</script>